import React, { Component, Fragment, createRef } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { ActionCreator } from "actions";
import { is, fromJS } from "immutable";
import * as queryString from "query-string";
import { GameAction } from "component/modal";
import translations from "translations";
import { isEmpty } from "lodash";
import { CommonHeader } from "component/common";
import { ReactComponent as LeftArrowIcon } from "assets/icons/left-chevron-svgrepo-com.svg";
import { ReactComponent as RightArrowIcon } from "assets/icons/right-chevron-svgrepo-com.svg";

import "containers/CategoryList/styles.scss";
import { setDefaultImageFormat } from "utils/image";

const ACTION_MODAL = "ACTION_MODAL";
//let isScrolling;

class CategoryList extends Component {
  constructor(props) {
    super(props);
    this.onGameItemClickHandler = this._onGameItemClickHandler.bind(this);
    this.launchActions = this._launchActions.bind(this);
    this.getNextGames = this._getNextGames.bind(this);
    this.getGames = this._getGames.bind(this);
    this.getTournamentPreview = this._getTournamentPreview.bind(this);
    this.categoryListRef = createRef();
    this.scrollingEventHandler = this._scrollingEventHandler.bind(this);
    this.rowRef = createRef();
    this.initLoadDelay = null;
    this.onShowMoreHandler = this._onShowMoreHandler.bind(this);
    this.onShowTournamentDetailsHandler = this._onShowTournamentDetailsHandler.bind(
      this
    );
    this.onShowTournamentResultHandler = this._onShowTournamentResultHandler.bind(
      this
    );
    this.onShowJackpotDetailsHandler = this._onShowJackpotDetailsHandler.bind(
      this
    );
    //this.checkReachEnd = this._checkReachEnd.bind(this);
    this.endRef = createRef();
    this.state = {
      initLoadList: true,
      isLoading: false,
      isLoadingNext: false,
      isScrolling: null,
      selectedGame: null,
      realUrl: null,
      demoUrl: null,
      detailsLink: null,
      detailsAvailable: false,
      startsIn: null,
      endsIn: null,
      skeleton: [1, 2, 3],
      snapIndex: null,
      hasNext: null,
      hasPrev: null,
      hasShowMore: null,
    };
  }

  _getNextGames() {
    if (
      (this.props.maxCount && this.props.maxCount === this.props.items.size) ||
      (this.props.games &&
        this.props.games.get("totalPages") === this.props.games.get("page"))
    ) {
      return;
    }

    let { page } = this.props.games.toJSON();

    let nextPage = page + 1;
    let params = {
      size: 10,
      page: nextPage,
    };
    this.setState({
      isLoadingNext: true,
    });
    this.props
      .fetchGames(this.props.link, params)
      .then(() => {
        this.setState({
          isLoadingNext: false,
        });
      })
      .catch((err) => {
        this.setState({
          isLoadingNext: false,
        });
      });
  }

  _getGames(link) {
    if (link) {
      let params = {
        size: 10,
      };

      this.setState({
        isLoading: true,
      });
      this.props
        .fetchGames(link, params)
        .then(() => {
          this.setState({
            isLoading: false,
          });
          return;
        })
        .catch((err) => {
          this.setState({
            isLoading: false,
          });
        });
    }
  }

  componentDidMount() {
    this.initObserver();
    //this.initScrollListener();
  }

  initScrollListener() {
    let isAtEnd =
      this.rowRef.current.scrollLeft + this.rowRef.current.clientWidth >=
      this.rowRef.current.scrollWidth - 1;

    this.setState({
      hasPrev: false,
      hasNext: !isAtEnd,
      hasShowMore: !isAtEnd,
    });

    this.rowRef.current.addEventListener("scroll", this.scrollingEventHandler);

    window.addEventListener("resize", this.scrollingEventHandler);
  }

  _scrollingEventHandler() {
    clearTimeout(this.state.isScrolling);

    this.setState({
      isScrolling: setTimeout(() => {
        let isAtEnd =
          this.rowRef.current.scrollLeft + this.rowRef.current.clientWidth >=
          this.rowRef.current.scrollWidth - 1;
        let isAtStart = this.rowRef.current.scrollLeft === 0;
        let hasPrev = !isAtStart;
        let hasNext = !isAtEnd;
        let hasShowMore = hasPrev || hasNext;

        this.setState({
          hasNext,
          hasPrev,
          hasShowMore,
        });
      }, 100),
    });
  }

  scrollPrev() {
    let parent = this.rowRef.current;
    let item = Array.from(parent.children)[0];
    let parentWidth = parent.getBoundingClientRect().width;
    let itemWidth = item.getBoundingClientRect().width;
    let itemVisiblePerRow = Math.floor(parentWidth / itemWidth);
    let currentSnappedItem = Math.round(parent.scrollLeft / itemWidth);
    let targetSnapIndex = currentSnappedItem - itemVisiblePerRow;
    targetSnapIndex = targetSnapIndex < 0 ? 0 : targetSnapIndex;
    let targetSnapItem = parent.children[targetSnapIndex];

    targetSnapItem.scrollIntoView({
      behavior: "smooth",
      block: "nearest", // prevents scrolling the whole page
      inline: "start",
    });
  }

  scrollNext() {
    let parent = this.rowRef.current;
    let item = Array.from(parent.children)[0];
    let parentWidth = parent.getBoundingClientRect().width;
    let itemWidth = item.getBoundingClientRect().width;
    let itemVisiblePerRow = Math.floor(parentWidth / itemWidth);
    let currentSnappedItem = Math.round(parent.scrollLeft / itemWidth);
    let targetSnapItem =
      parent.children[currentSnappedItem + itemVisiblePerRow];

    //targetSnapItem.classList.add("highlight");
    targetSnapItem.scrollIntoView({
      behavior: "smooth",
      block: "nearest", // prevents scrolling the whole page
      inline: "start",
    });
  }

  componentDidUpdate(prevProps) {
    if (!is(prevProps.items, this.props.items) && prevProps.items.size === 0) {
      this.initScrollListener();
    }
  }

  initObserver() {
    if (
      "IntersectionObserver" in window &&
      "IntersectionObserverEntry" in window &&
      "intersectionRatio" in window.IntersectionObserverEntry.prototype
    ) {
      let observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              if (
                this.categoryListRef.current === entry.target &&
                !this.props.games
              ) {
                this.initLoadDelay = setTimeout(() => {
                  this.getGames(this.props.link);
                  this.getTournamentPreview(this.props.links);
                  clearInterval(this.initLoadDelay);
                }, 500);
              } else if (
                this.props.games &&
                this.endRef.current === entry.target
              ) {
                this.getNextGames(this.props.link);
                this.getTournamentPreview(this.props.links);
              }
            } else {
              if (this.categoryListRef.current) {
                clearInterval(this.initLoadDelay);
              }
            }
          });
        },
        {
          root: document.getElementsByClassName(
            "main-content d-flex flex-column"
          )[0],
          rootMargin: "500px 500px 500px 500px",
          threshold: 0.001,
        }
      );
      observer.observe(this.categoryListRef.current);
      observer.observe(this.endRef.current);
    }
  }

  _getTournamentPreview(links) {
    if (!links) return;

    let link = links.find((link) => {
      return link.get("rel").indexOf("tournament.preview") > -1;
    });
    if (link)
      this.props.fetchTournamentPreview(link, {
        parentRel: this.props.link.get("rel"),
      });
  }

  _onShowTournamentDetailsHandler(rel, links, images, providers, tab) {
    let params = {
      showTournamentDetails: rel,
      routes: btoa(encodeURIComponent(JSON.stringify(links.toJSON()))),
      tab: tab,
    };

    if (images) {
      params.images = btoa(encodeURIComponent(JSON.stringify(images.toJSON())));
    }

    if (providers) {
      params.providers = btoa(
        encodeURIComponent(JSON.stringify(providers.toJSON()))
      );
    }

    let newLoc = `${this.props.location.pathname}?${queryString.stringify(
      params
    )}`;
    this.props.navigateTo(newLoc);
  }

  _onShowTournamentResultHandler(rel, route, images, providers) {
    let params = {
      showTournamentResults: rel,
      route: btoa(encodeURIComponent(JSON.stringify(route.toJSON()))),
    };

    if (images) {
      params.images = btoa(encodeURIComponent(JSON.stringify(images.toJSON())));
    }

    if (providers) {
      params.providers = btoa(JSON.stringify(providers.toJSON()));
    }

    let newLoc = `${this.props.location.pathname}?${queryString.stringify(
      params
    )}`;
    this.props.navigateTo(newLoc);
  }

  _onShowJackpotDetailsHandler(rel, links, images, providers, isWinner) {
    let params = {
      showJackpotDetails: rel,
      routes: btoa(encodeURIComponent(JSON.stringify(links.toJSON()))),
      isWinnerView: isWinner,
    };

    if (images) {
      params.images = btoa(JSON.stringify(images.toJSON()));
    }

    if (providers) {
      params.providers = btoa(JSON.stringify(providers.toJSON()));
    }

    let newLoc = `${this.props.location.pathname}?${queryString.stringify(
      params
    )}`;
    this.props.navigateTo(newLoc);
  }

  _onShowMoreHandler(
    rel,
    route,
    images,
    providers,
    status,
    subtitle,
    highestJpPoolAmount
  ) {
    if (
      rel !== "jackpots" &&
      rel !== "tournaments" &&
      rel !== "new-providers" &&
      rel !== "popular.providers"
    ) {
      route = route.setIn(["rel"], `show.more.${route.getIn(["rel"])}`);
      rel = `${route.getIn(["rel"])}`;
    }
    let params = {
      showMore: rel,
      route: btoa(encodeURIComponent(JSON.stringify(route.toJSON()))),
      status: status,
      JpSubtitle: subtitle,
      JpAmount: highestJpPoolAmount,
    };

    if (images) {
      params.images = btoa(encodeURIComponent(JSON.stringify(images.toJSON())));
    }

    if (providers) {
      params.imaprovidersges = btoa(
        encodeURIComponent(JSON.stringify(providers.toJSON()))
      );
    }

    let newLoc = `${this.props.location.pathname}?${queryString.stringify(
      params
    )}`;
    this.props.navigateTo(newLoc);
  }

  componentWillUnmount() {
    this.props.clearGames(this.props.link);
    this.rowRef.current.removeEventListener(
      "scroll",
      this.scrollingEventHandler
    );
    window.removeEventListener("resize", this.scrollingEventHandler);
  }

  _launchActions(game) {
    let {
      locale,
      sessionId,
      page,
      category,
      subCategory,
    } = this.props.match.params;
    let realLink;
    let demoLink;
    let detailsLink;
    let params;
    let categoryPath = this.props.match.path.split("/")[3];

    if (category) {
      params = {
        returnUrl: `${window.location.protocol}//${window.location.host}/${[
          locale,
          sessionId,
          categoryPath,
          page,
          category,
          subCategory,
        ].join("/")}`,
      };
    } else {
      params = {
        returnUrl: `${window.location.protocol}//${window.location.host}/${[
          locale,
          sessionId,
          categoryPath,
          page,
          subCategory,
        ].join("/")}`,
      };
    }

    this.setState({
      realUrl: null,
      demoUrl: null,
    });

    try {
      detailsLink = game.get("links").find((link) => {
        return link.get("rel") === "launch.real";
      });
      this.setState({
        detailsLink: detailsLink,
      });
    } catch (err) {}

    try {
      realLink = game.get("links").find((link) => {
        return link.get("rel") === "launch.real";
      });
      this.props.fetchGameUrl(realLink, params).then((response) => {
        let realUrl = response.payload.data.url;
        this.setState({
          realUrl: realUrl,
        });
      });
    } catch (err) {}

    try {
      demoLink = game.get("links").find((link) => {
        return link.get("rel") === "launch.demo";
      });
      this.props.fetchGameUrl(demoLink, params).then((response) => {
        let demoUrl = response.payload.data.url;
        this.setState({
          demoUrl: demoUrl,
        });
      });
    } catch (err) {}
    this.props.showModal(ACTION_MODAL);
    this.setState({
      selectedGame: game,
    });
  }

  _onGameItemClickHandler(game, rel) {
    let gameId = game.get("gameId");
    let nav = this.props.link ? this.props.link.get("rel") : null;
    this.props.gameClick(gameId, rel, nav, game).then((response) => {
      if (response.location) {
        this.props.navigateTo(response.location);
      } else if (response.params) {
        this.props.setGameAction(response.params);
      }
    });
  }

  renderGameListItem(game, key) {
    let ComponentListItem = this.props.listItemComponent;
    let linkDemo = game.get("links").find((link) => {
      return link.get("rel") === "launch.demo";
    });
    let linkReal = game.get("links").find((link) => {
      return link.get("rel") === "launch.real";
    });
    let linkDetails = game.get("links").find((link) => {
      return link.get("rel") === "game.details";
    });

    return (
      <ComponentListItem
        key={key}
        game={game}
        linkDemo={linkDemo}
        linkReal={linkReal}
        linkDetails={linkDetails}
        host={this.props.host}
        isMobile={this.props.isMobile}
        onClick={(rel) => {
          if (linkReal && this.props.isOneClickPlayEnabled)
            return this.onGameItemClickHandler(game, linkReal.get("rel"));
          if (linkDemo && this.props.isOneClickPlayEnabled)
            return this.onGameItemClickHandler(game, linkDemo.get("rel"));
          return this.onGameItemClickHandler(game, rel);
        }}
        onShowActionClick={() => {
          this.launchActions(game);
        }}
        currency={this.props.currency}
        symbol={this.props.symbol}
        imageFormat={this.props.imageFormat}
        latestBroadcast={this.props.latestBroadcast}
        parent={this.rowRef.current}
        isOneClickPlayEnabled={this.props.isOneClickPlayEnabled}
      />
    );
  }

  renderProviderListItem(item, key) {
    let ComponentListItem = this.props.listItemComponent;
    //TODO: add checking
    let categoryLink = item.getIn(["links", 0]);
    categoryLink = categoryLink.setIn(
      ["rel"],
      `show.more.${categoryLink.get("rel")}`
    );

    return (
      <ComponentListItem
        key={key}
        game={item}
        isMobile={this.props.isMobile}
        onClick={(rel) => {
          this.onShowMoreHandler(categoryLink.get("rel"), categoryLink);
        }}
        imageFormat={this.props.imageFormat}
        latestBroadcast={this.props.latestBroadcast}
      />
    );
  }

  renderJackpotListItem(item, key) {
    let ComponentListItem = this.props.listItemComponent;
    let detailsLink = item.get("links").find((link) => {
      return link.get("rel").indexOf("jackpot-details") > -1;
    });
    let gamesLink = item.get("links").find((link) => {
      return link.get("rel").indexOf("jackpot-games") > -1;
    });
    let images = item.get("images");
    let providers = item.get("providers");

    return (
      <ComponentListItem
        key={key}
        game={item}
        isMobile={this.props.isMobile}
        onClick={(rel) => {
          this.onShowJackpotDetailsHandler(
            detailsLink.get("rel"),
            item.get("links"),
            images,
            providers,
            true
          );
        }}
        onViewWinnersClick={() => {
          this.onShowJackpotDetailsHandler(
            detailsLink.get("rel"),
            item.get("links"),
            images,
            providers,
            true
          );
        }}
        onViewGamesClick={() => {
          gamesLink = gamesLink.setIn(["name"], item.get("title"));
          this.onShowJackpotDetailsHandler(
            detailsLink.get("rel"),
            item.get("links"),
            images,
            providers,
            false
          );
        }}
        latestBroadcast={this.props.latestBroadcast}
        currency={this.props.currency}
        symbol={this.props.symbol}
        fetchGameTypes={this.props.fetchGameTypes}
        imageFormat={this.props.imageFormat}
      />
    );
  }

  renderTournamentListItem(item, key) {
    let ComponentListItem = this.props.listItemComponent;
    let detailsLink = item.get("links").find((link) => {
      return link.get("rel").indexOf("tournament-promotions") > -1;
    });
    let resultsLink = item.get("links").find((link) => {
      return link.get("rel").indexOf("tournament-leaderboard") > -1;
    });
    let images = item.get("images");
    let providers = item.get("providers");

    return (
      <ComponentListItem
        key={key}
        game={item}
        host={this.props.host}
        isMobile={this.props.isMobile}
        onClick={() => {
          let links = item.get("links");
          let tab;
          links.forEach((link, key) => {
            links = links.setIn([key, "name"], item.get("title"));
          });
          resultsLink ? (tab = "results") : (tab = "games");
          this.onShowTournamentDetailsHandler(
            detailsLink.get("rel"),
            links,
            images,
            providers,
            tab
          );
        }}
        onViewGamesClick={() => {
          let links = item.get("links");
          links.forEach((link, key) => {
            links = links.setIn([key, "name"], item.get("title"));
          });
          this.onShowTournamentDetailsHandler(
            detailsLink.get("rel"),
            links,
            images,
            providers,
            "games"
          );
        }}
        onViewResultsClick={() => {
          let links = item.get("links");
          links.forEach((link, key) => {
            links = links.setIn([key, "name"], item.get("title"));
          });
          this.onShowTournamentDetailsHandler(
            detailsLink.get("rel"),
            links,
            images,
            providers,
            "results"
          );
        }}
        latestBroadcast={this.props.latestBroadcast}
        currency={this.props.currency}
        symbol={this.props.symbol}
        fetchGameTypes={this.props.fetchGameTypes}
        imageFormat={this.props.imageFormat}
      />
    );
  }

  renderFreeRoundsListItem(item, key) {
    let ComponentListItem = this.props.listItemComponent;
    let detailsLink;
    try {
      detailsLink = item
        .get("links")
        .find((link) => link.get("rel") === "rewards.details");
    } catch (err) {}

    let rel;
    try {
      let realLink = item
        .get("links")
        .find((link) => link.get("rel") === "launch.real");
      rel = realLink.get("rel");
    } catch (err) {}

    let gameId;
    try {
      gameId = item.getIn(["claimedGame", "id"]);
    } catch (err) {}

    return (
      <ComponentListItem
        key={key}
        game={item}
        currency={this.props.currency}
        onClick={() => {
          if (detailsLink)
            this.props.openFreeRoundDetails(detailsLink, this.props.navigateTo);
        }}
        continuePlaying={() => {
          this.props.gameClick(gameId, rel).then((response) => {
            if (response.location) {
              this.props.navigateTo(response.location);
            } else if (response.params) {
              this.props.setGameAction(response.params);
            }
          });
        }}
      />
    );
  }

  renderListItem(game, key) {
    switch (this.props.link.get("rel")) {
      case "jackpots":
        return this.renderJackpotListItem(game, key);
      case "tournaments":
        return this.renderTournamentListItem(game, key);
      case "providers":
      case "new-providers":
      case "popular.providers":
        return this.renderProviderListItem(game, key);
      case "rewards":
        return this.renderFreeRoundsListItem(game, key);
      default:
        return this.renderGameListItem(game, key);
    }
  }

  renderPlaceHolder(template, key) {
    let placeholderType;
    switch (template.get("size")) {
      case "l":
        placeholderType = "placeholder-type-7";
        break;
      case "m":
        placeholderType = "placeholder-type-5";
        break;
      default:
        placeholderType = null;
        break;
    }
    let ComponentListItem = this.props.listItemComponent;
    return <ComponentListItem key={key} placeholderType={placeholderType} />;
  }

  render() {
    return (
      <Fragment>
        <div
          className={`categoryList ${this.props.hasNoItems ? "d-none" : ""}`}
          ref={this.categoryListRef}
          onClick={(event) => {
            if (this.state.hasShowMore) {
              //TODO: is this a valid condition
              event.stopPropagation();
              this.onShowMoreHandler(
                this.props.link.get("rel"),
                this.props.link
              );
            }
          }}
        >
          {this.state.selectedGame && (
            <GameAction
              isMobile={this.props.isMobile}
              game={this.state.selectedGame}
              sizeSuffix={this.props.sizeSuffix}
              imgSrc={`${setDefaultImageFormat(
                this.state.selectedGame.getIn(["images", "bannerUrl"]) +
                  "&width=180&theme=dark",
                this.props.imageFormat.get("banner")
              )}`}
              realUrl={this.state.realUrl}
              demoUrl={this.state.demoUrl}
              onClose={() => {
                this.props.hideModal(ACTION_MODAL);
                this.setState({
                  selectedGame: null,
                });
              }}
              onClick={(rel) => {
                this.props.hideModal(ACTION_MODAL);
                this.onGameItemClickHandler(this.state.selectedGame, rel);
                this.setState({
                  selectedGame: null,
                });
              }}
            />
          )}
          <div>
            {!this.state.isLoading && this.props.games && (
              <CommonHeader
                link={this.props.link}
                tournamentPreview={this.props.tournamentPreview}
                detailsAvailable={this.props.detailsAvailable}
                onInfoClick={() => {
                  let params = {
                    tournamentDetails: this.props.link.get("rel"),
                  };
                  let newLoc = `${
                    this.props.location.pathname
                  }?${queryString.stringify(params)}`;
                  this.props.navigateTo(newLoc);
                }}
                rightPanel={
                  this.state.hasShowMore
                    ? () => {
                        return (
                          <div className="d-flex align-items-center h-100">
                            <button
                              className="btn btn-dark"
                              onClick={(event) => {
                                event.stopPropagation();
                                let moreLink = this.props.link;
                                //moreLink = moreLink.setIn(['rel'], `show.more.${moreLink.get('rel')}`)
                                this.onShowMoreHandler(
                                  moreLink.get("rel"),
                                  moreLink
                                );
                              }}
                            >
                              {translations("showMore")}
                            </button>
                          </div>
                        );
                      }
                    : null
                }
              />
            )}
            {this.state.isLoading && (
              <div className="placeholder-name">
                <div className="dummy" />
              </div>
            )}

            <div className="row item-container" ref={this.rowRef}>
              {this.props.items &&
                this.props.items.map((game, key) => {
                  return (
                    <div
                      className={`col template-${this.props.template.get(
                        "size"
                      )}`}
                      key={key}
                    >
                      {this.renderListItem(game, key)}
                    </div>
                  );
                })}
              {
                <div
                  className={`col no-snap template-${this.props.template.get(
                    "size"
                  )} col-end ${
                    this.state.isLoading ||
                    (!this.state.isLoading && !this.state.isLoadingNext)
                      ? ""
                      : "d-none"
                  } ${this.props.hasNextPage ? "" : "d-none"}
                  `}
                  ref={this.endRef}
                >
                  {this.renderPlaceHolder(this.props.template, 100)}
                </div>
              }
              {this.state.skeleton.map((item, key) => {
                return (
                  <div
                    className={`col no-snap template-${this.props.template.get(
                      "size"
                    )} ${this.props.hasNextPage ? "" : "d-none"}`}
                    key={key}
                  >
                    {this.renderPlaceHolder(this.props.template, key)}
                  </div>
                );
              })}
            </div>
            <div className="list-navigation">
              <span
                onClick={(event) => {
                  this.scrollPrev();
                  event.stopPropagation();
                }}
                className={`prev text-center d-flex align-items-center ${
                  !this.state.hasPrev ? "disabled" : ""
                }`}
                disabled={!this.state.hasPrev}
                alt="prev"
              >
                <LeftArrowIcon />
              </span>
              <span
                onClick={(event) => {
                  this.scrollNext();
                  event.stopPropagation();
                }}
                disabled={!this.state.hasNext}
                className={`next text-center d-flex align-items-center ${
                  !this.state.hasNext ? "disabled" : ""
                }`}
                alt="next"
              >
                <RightArrowIcon />
              </span>
            </div>
          </div>
        </div>
      </Fragment>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  let games;
  let isLoading = true;
  let items = fromJS([]);
  let symbols = null;
  let currency = null;
  let detailsAvailable = null;
  let tournamentPreview = null;
  let { showMore } = queryString.parse(ownProps.location.search);
  let template;
  let hasNextPage = true;
  let hasNoItems;
  let latestBroadcast;

  try {
    template = ownProps.link.get("templates").find((template) => {
      return template.get("id") === "myQT";
    });
  } catch (err) {
    template = fromJS({ size: "m" });
  }

  try {
    latestBroadcast = state.serverSentEvent.getIn(["latestBroadcast"]);
  } catch (err) {}

  try {
    games = state.games.getIn([ownProps.link.get("rel"), "data"]);
  } catch (err) {}
  try {
    isLoading = state.games.getIn([ownProps.link.get("rel"), "isLoading"]);
  } catch (err) {}
  try {
    items = games.get("items");
  } catch (err) {}
  try {
    tournamentPreview = state.tournaments.get(ownProps.link.get("rel"));
  } catch (err) {}
  try {
    detailsAvailable = state.games.getIn([
      ownProps.link.get("rel"),
      "route",
      "links",
    ])
      ? true
      : false;
  } catch (err) {}

  try {
    hasNoItems = games.get("totalCount") === 0;
  } catch (err) {}

  try {
    if (games.get("totalPages") > games.get("page")) {
      hasNextPage = true;

      if (ownProps.maxCount) {
        hasNextPage = ownProps.maxCount > items.size;
      }
    } else {
      hasNextPage = false;
    }
  } catch (err) {}

  if (!isEmpty(state.links.getIn(["symbol"]))) {
    let symbolList = state.links.getIn(["symbol"]);
    symbolList = symbolList.map((symbol) => {
      return String.fromCharCode(symbol);
    });
    symbols = symbolList.toJSON().join("");
  }

  if (!isEmpty(state.links.get("currency"))) {
    currency = state.links.get("currency");
  }

  return {
    hasNoItems,
    hasNextPage,
    gameDefaultAction: state.links.get("gameDefaultAction")
      ? state.links.get("gameDefaultAction")
      : null,
    detailsAvailable,
    host: state.config.get("host"),
    height: state.window.get("height"),
    gameAction: state.game,
    games: games,
    items: items,
    currency: currency,
    symbol: symbols,
    isLoading: isLoading,
    isMobile: state.window.get("isMobile"),
    links: ownProps.link.get("links"),
    gamesRoute: ownProps.link,
    tournamentPreview: tournamentPreview,
    showMore,
    template,
    latestBroadcast,
    isMultiGame: state.links.get("isMultiGame"),
    imageFormat: state.window.get("imageFormat"),
    isOneClickPlayEnabled: state.links.get("isOneClickPlayEnabled"),
  };
};

const mapDispatchToProps = (dispatch, ownProps) => {
  return bindActionCreators(ActionCreator, dispatch);
};

const mergeProps = (stateProps, dispatchProps, ownProps) => {
  return Object.assign({}, stateProps, ownProps, {
    setGameAction: (params) => dispatchProps.setGameAction(params),
    fetchGames: (route, params) => dispatchProps.fetchGames(route, params),
    clearGames: (route) => dispatchProps.clearGames(route),
    fetchGameUrl: (link, params) => dispatchProps.fetchGameUrl(link, params),
    fetchTournamentPreview: (link, params) =>
      dispatchProps.fetchTournamentPreview(link, params),
    showModal: (modal) => dispatchProps.showModal(modal),
    hideModal: (modal) => dispatchProps.hideModal(modal),
    showSeeAllCategory: (rel) => dispatchProps.showSeeAllCategory(rel),
    hideSeeAllCategory: (rel) => dispatchProps.hideSeeAllCategory(rel),
    fetchGameTypes: (route) => dispatchProps.fetchGameTypes(route),
    openFreeRoundDetails: (route, navigateTo) =>
      dispatchProps.openFreeRoundDetails(route, navigateTo),
    gameClick: (gameId, playType, nav, game) =>
      dispatchProps.gameClick(gameId, playType, nav, game),
  });
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
  mergeProps
)(CategoryList);
